import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from '@app/app.component';
import { AppRoutingModule } from '@app/app-routing.module';
import { AuthModule } from '@app/auth/auth.module';
import { bootstrapProvider } from '@app/core/config/bootstrap-provider';
import { CoreModule } from '@app/core/core.module';
import { ConfigEffects } from '@app/core/effects/config.effects';
import { TranslationsEffects } from '@app/core/effects/translations.effects';
import { PcsModalModule } from '@app/core/pcs-modal';
import { PcsModule } from '@app/pcs/pcs.module';
import { metaReducers, reducers } from '@app/reducer';
import { environment } from '@env/environment';
import { EffectsModule } from '@ngrx/effects';
import { NavigationActionTiming, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CustomRouterStateSerializer } from '@util/routing';

// configuration for the store
const storeConfig = {
  metaReducers,
  // TODO HD enable state and action immutability checks when https://github.com/ngrx/platform/issues/2109 is fixed.
  // Currently we have angular components in the actions and the grid store and ngrx freezes the component fields, thus
  // makes them read-only. Ivy expects that some of the fields will be writable and because the fields will be frozen
  // it won't be able to do it.
  runtimeChecks: {
    strictStateImmutability: false,
    strictActionImmutability: false
  }
};

// configuration for the store router
const storeRouterConfig = {
  //  defines the name of the state used by the router-store reducer
  stateKey: 'router',
  serializer: CustomRouterStateSerializer,
  navigationActionTiming: NavigationActionTiming.PostActivation
};

// configuration for the store devtools
const storeDevtoolsConfig = {
  name: 'PCS EC',
  logOnly: environment.production,
  // maximum allowed actions to be stored in the history tree.
  maxAge: 30
};

const rootEffects = [
  ConfigEffects,
  TranslationsEffects
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(reducers, storeConfig),
    StoreRouterConnectingModule.forRoot(storeRouterConfig),
    StoreDevtoolsModule.instrument(storeDevtoolsConfig),
    EffectsModule.forRoot(rootEffects),

    CoreModule,

    PcsModalModule.forRoot({
      stateKey: 'modal'
    }),

    AuthModule,
    PcsModule,
    AppRoutingModule
  ],
  providers: [
    bootstrapProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
